import { Button, Space, Table } from "antd";
import React from "react";
import { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import { request } from "../../../config/API";
import { ReloadOutlined } from "@ant-design/icons";
import authHeader from "../../../redux/services/authHeader";
import { COLORS } from "../../../config/theme";
import styles from "./ListSubusers.module.css";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
const ListSubusers = () => {
  const { primaryDark } = COLORS;
  const [subusers, setSubusers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // pagination
  const [count, setCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }
  const getSubusers = () => {
    setIsLoading(true);
    request
      .get("user/subuser", {
        params: { pageSize, pageNumber: currentPage },
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setSubusers(data?.admin);
        setCount(data?.count);
        setIsLoading(false);
        // setAdmins(data?.admin);
      })
      .catch((err) => {
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  useEffect(getSubusers, [currentPage, pageSize]);

  const columns = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "id",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: styles.antRow,
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      className: styles.antRow,
    },
    {
      title: "Card Allowed",
      dataIndex: "qrAllowed",
      key: "qrAllowed",
      className: styles.antRow,
      width: "15%",
    },
    {
      title: "Card Unused",
      dataIndex: "qrUnused",
      key: "qrUnused",
      className: styles.antRow,
      width: "15%",
    },
  ];
  return (
    <Layout heading="Sub Users" hasBadge stat={count}>
      <Space style={{ marginBottom: 24, float: "right" }} wrap={true}>
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={getSubusers}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>
      <Table
        size="large"
        dataSource={subusers}
        rowKey={({ _id }) => _id}
        columns={columns}
        loading={isLoading}
        pagination={{
          hideOnSinglePage: true,
          pageSize: pageSize,
          current: currentPage,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          // showTotal: (total) => `Total ${total} items`,
          onChange: handlePageChange,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
        }}
      />
    </Layout>
  );
};

export default ListSubusers;
